import { IConnectedDevice } from '../../ts/ServerApi/types/IConnectedDevice';
import React = require('react');
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { Messages, Formatters } from '../../codegen/Localize';
import { ButtonWidget, ButtonType, Tooltip, TooltipPosition } from '@tableau/widgets';
import { L10n } from '../../ts/L10n/L10n'; import { HelpService } from '../../commonInfra/services/HelpService';
import { imgPath } from '../../common/utilities/ImgUrl';
import { User } from '../../app/spaces/Tooltips/Elements/User';
import { ServerUsers } from '../../userManagement/services/resources/ServerUsers';
import { IServerUser } from '../../ts/ServerApi/types/IServerUser';
import { showDeleteConnectedDeviceDialog } from '../services/DeleteConnectedDeviceAction';


export interface ConnectedDeviceSectionProps {
  serverUser: IServerUser;
}

export function ConnectedDevices(props: ConnectedDeviceSectionProps) {
  const [connectedDevices, setConnectedDevices] = React.useState([] as IConnectedDevice[]);

  async function refreshConnectedDevices() {
    const connectedDevices: IConnectedDevice[] = await ServerUsers.instance.getUserConnectedDevices(props.serverUser.id);
    setConnectedDevices(connectedDevices);
  }

  async function deleteConnectedDevice(device: IConnectedDevice) {
    await showDeleteConnectedDeviceDialog(device, props.serverUser.id);
    refreshConnectedDevices();
  }

  React.useEffect(() => {
    refreshConnectedDevices();
  }, []);

  return (
    <table>
      <tbody>
        <tr>
          <td className={UserSettingsStyle.labelTextNew} data-tb-test-id="usersetting-ConnectedClients-label">
            {Messages.serverConnectedDevices()}
          </td>
          <td data-tb-test-id="usersetting-connectedClients-description" className={UserSettingsStyle.detailsValue}>
            {Messages.connectedDevicesDescription()}
            <a className="tb-lr-padded" rel="noopener noreferrer" target="_blank" href={HelpService.getServerHelpUrlByCategory('manage-cred')}>
              <span>{Messages.connectedDevicesLearnMore()}</span>
            </a>
          </td>
        </tr>
        <tr>
          <td className={UserSettingsStyle.labelTextNew}></td>
          <td className={UserSettingsStyle.detailsValue} colSpan={2}> {connectedDevices && connectedDevices.length > 0 ? renderDeviceList(props, connectedDevices, deleteConnectedDevice) :
            <span data-tb-test-id="no-connected-clients">{Messages.noConnectedDevices()} </span>}</td>
        </tr>
      </tbody>
    </table>
  );
}

function renderPopOver(count: number) {
  return (
    <Tooltip
      testId={'userSetting-connectedDevices-Popover'}
      position={TooltipPosition.Right}
      maxWidth={200}
      getContent={() => getTooltipContent(count)}
    >
      <div className="tb-header-row-icon-centered tb-icon-help" />
    </Tooltip>
  );
}

function getTooltipContent(count: number) {
  return new Promise<JSX.Element>(resolve => {
    window.setTimeout(() => {
      resolve(<span>{
        Messages.connectedDeviceDatasources({
          COUNT: count,
          COUNT_LOC: Formatters.formatCount(count)
        })
      }</span>);
    }, 150);
  });
}

function renderDeviceList(props: ConnectedDeviceSectionProps, connectedDevices: IConnectedDevice[], deleteConnectedDevice: (device: IConnectedDevice) => void) {
  return (
    <>
      <div className="tb-user-settings-item-table">
        <table className="tb-static-grid-table tb-static-grid-table-settings-width">
          <tr data-tb-test-id="connected-devices-table-header">
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text">
                {Messages.connectedDeviceName()}
              </span>
            </th>
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text">
                {Messages.connectedDeviceLastConnected()}
              </span>
            </th>
            <th className={UserSettingsStyle.tableHeaderLine}>
              <span className="tb-data-grid-header-text">
              </span>
            </th>
          </tr>
          {
            connectedDevices.map((connectedDevice, index) => {
              return (
                <tr key={index} data-tb-test-id="connected-devices-list">
                  <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>
                    <div className="tb-data-grid-cell-text">
                      <span className={UserSettingsStyle.itemTableName} title={connectedDevice.displayName}>
                        {connectedDevice.displayName}
                        {connectedDevice.remoteAgent && connectedDevice.connectedDatasourcesCount &&
                          renderPopOver(connectedDevice.connectedDatasourcesCount)}
                      </span>
                    </div>
                  </td>
                  <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>
                    <span className="tb-data-grid-cell-text">{L10n.localizedDateTime(connectedDevice.lastUsed)}</span>
                  </td>
                  <td className={UserSettingsStyle.tableMultilineWithSeparatorRow}>
                    <ButtonWidget
                      title={Messages.remove()}
                      buttonType={ButtonType.LowEmphasis}
                      testId={'userSetting-delete-connected-device'}
                      onClick={() => deleteConnectedDevice(connectedDevice)}
                    >
                      <img src={imgPath('trash_14px_small.svg')} alt="" /><span>{' ' + Messages.remove()}</span>
                    </ButtonWidget>
                  </td>
                </tr>
              );
            })
          }
        </table>
      </div>
    </>
  );
}